import React from 'react';
import { FileSearch, FileText, Calculator, FileCheck } from 'lucide-react';
import ReportGenerator from './modules/ReportGenerator';
import TechnicalInterview from './modules/TechnicalInterview';

function App() {
  const [selectedModule, setSelectedModule] = React.useState<string | null>(null);

  // Parse initial module from URL path
  React.useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/report')) {
      setSelectedModule('report-generator');
    } else if (path.includes('/interview')) {
      setSelectedModule('technical-interview');
    }
  }, []);

  // Update URL path when module changes
  const handleModuleChange = (moduleId: string | null) => {
    setSelectedModule(moduleId);
    
    if (moduleId === 'report-generator') {
      window.history.pushState({}, '', '/report');
    } else if (moduleId === 'technical-interview') {
      window.history.pushState({}, '', '/interview');
    } else {
      window.history.pushState({}, '', '/');
    }
  };

  const modules = [
    {
      id: 'report-generator',
      name: 'Gerador de Relatórios',
      description: 'Gere relatórios detalhados de ações do e-Hub',
      icon: FileSearch,
      available: true,
    },
    {
      id: 'technical-interview',
      name: 'Entrevista Técnica',
      description: 'Avalie candidatos durante entrevistas técnicas',
      icon: FileCheck,
      available: true,
    },
    {
      id: 'content-generator',
      name: 'Gerador de Conteúdo',
      description: 'Crie conteúdo automatizado baseado em ações realizadas',
      icon: FileText,
      available: false,
    },
    {
      id: 'estimate-generator',
      name: 'Gerador de Estimativas',
      description: 'Calcule estimativas precisas para projetos e tarefas',
      icon: Calculator,
      available: false,
    },
  ];

  if (selectedModule === 'report-generator') {
    return <ReportGenerator onBack={() => handleModuleChange(null)} />;
  }

  if (selectedModule === 'technical-interview') {
    return <TechnicalInterview onBack={() => handleModuleChange(null)} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            e-Hub Toolbox
          </h1>
          <p className="text-xl text-gray-600">
            Ferramentas essenciais para otimizar o trabalho da equipe
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {modules.map((module) => (
            <div
              key={module.id}
              className={`
                relative group bg-white rounded-xl shadow-md overflow-hidden
                transition-all duration-300 hover:shadow-xl
                ${module.available ? 'cursor-pointer' : 'cursor-not-allowed opacity-75'}
              `}
              onClick={() => module.available && handleModuleChange(module.id)}
            >
              <div className="p-8">
                <div className="flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6 mx-auto">
                  <module.icon className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 text-center mb-2">
                  {module.name}
                </h3>
                <p className="text-gray-600 text-center">
                  {module.description}
                </p>
                {!module.available && (
                  <div className="absolute inset-0 bg-white bg-opacity-90 flex items-center justify-center">
                    <span className="px-4 py-2 bg-gray-200 text-gray-700 rounded-full text-sm font-medium">
                      Em breve
                    </span>
                  </div>
                )}
              </div>
              {module.available && (
                <div className="absolute bottom-0 inset-x-0 h-1 bg-blue-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
              )}
            </div>
          ))}
        </div>

        <footer className="mt-16 text-center text-gray-600">
          <p>Desenvolvido pelo Hub de Engenharia da Zallpy</p>
        </footer>
      </div>
    </div>
  );
}

export default App;